import {
  Reg28InfrastructureExposureMaxLimitsResponseModelMock,
  Reg28InfrastructureExposureResponseModelMock,
  Reg28InfrastructureExposureWeightsResponseModelMock
} from '../../../../types/regulation-28/regulation-28.interfaces';
import { ExposureTable } from '../../../../../../components/organisms/exposure-table/ExposureTable';

type InfrastructureExposureTableProps = {
  tableData: Reg28InfrastructureExposureResponseModelMock[];
  maxLimits?: Reg28InfrastructureExposureMaxLimitsResponseModelMock;
  weights?: Reg28InfrastructureExposureWeightsResponseModelMock;
};

export const Reg28InfrastructureExposureTable = ({
  tableData,
  maxLimits,
  weights
}: InfrastructureExposureTableProps) => {
  return (
    <ExposureTable
      columns={[
        {
          displayValue: 'Collective investment funds',
          align: 'left'
        },
        {
          displayValue: '%',
          align: 'right',
          maximumPercentage: maxLimits?.percentage,
          weightedPercentage: weights?.percentage
        },
        {
          displayValue: 'Total infrastructure %',
          align: 'right',
          // Defaulting to 100 for now, core ticket should investigate where value comes from.
          maximumPercentage: 100,
          weightedPercentage: 100
        }
      ]}
      rows={tableData.map((data) => ({
        values: [
          {
            rawValue: data.fundName,
            displayValue: data.fundName,
            align: 'left'
          },
          {
            rawValue: data.percentage ?? 0,
            displayValue: data.percentage?.toFixed(2) ?? '-',
            align: 'right'
          },
          {
            // Summing this for now, core ticket should investigate where value comes from.
            rawValue: (data.local ?? 0) + (data.foreign ?? 0),
            displayValue: ((data.local ?? 0) + (data.foreign ?? 0)).toFixed(2) ?? '-',
            align: 'right'
          }
        ]
      }))}
    />
  );
};
